export const splitFile = (filename = '') => filename.split('.');

export const getFilename = (filename) => {
	const pieces = splitFile(filename);

	if (pieces.length === 1) {
		return pieces[0];
	}

	return pieces[pieces.length - 2] || '';
};

export const getExtention = (filename) => {
	const pieces = splitFile(filename);

	// no ext
	if (pieces.length === 1) {
		return '';
	}

	return pieces[pieces.length - 1] || '';
};

export const isStripeVersionLoaded = (v) => {
	const scripts = document.querySelectorAll(`script[src="https://js.stripe.com/${v}"]`);
	return scripts.length > 0;
};

// this is done because we have 2 flow old and new flow of stripe. createToken requires v2 but when old version is removed then we wont need to do this
export const removeStripeVersion = (v) => {
	const scripts = document.querySelectorAll(`script[src="https://js.stripe.com/${v}"]`);
	scripts.forEach((script) => {
		script.remove(); // Remove the v script if it exists
	});
};

export const loadFile = (src, onload) => {
	const script = document.createElement('script');
	script.type = 'text/javascript';
	script.onload = onload;
	script.src = src;
	document.head.appendChild(script);
	return script;
};

export const base64ToBrowser = (buffer) => {
	return window.btoa(
		[].slice
			.call(new Uint8Array(buffer))
			.map(function (bin) {
				return String.fromCharCode(bin);
			})
			.join('')
	);
};

export const pdfToBase64 = (urlOrPdf) => {
	return fetch(urlOrPdf)
		.then(function (response) {
			return response.arrayBuffer();
		})
		.then(base64ToBrowser);
};
